import React from 'react';

class IrTvIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_254_1405)">
          <g filter="url(#filter0_d_254_1405)">
            <path
              d="M68.2 17H11.8C9.14903 17 7 19.149 7 21.8V50.2C7 52.851 9.14903 55 11.8 55H68.2C70.851 55 73 52.851 73 50.2V21.8C73 19.149 70.851 17 68.2 17Z"
              fill="#F7F4F1"
            />
            <path
              d="M73 48V50.2C73 52.85 70.85 55 68.2 55H11.8C9.15 55 7 52.85 7 50.2V48H73Z"
              fill="white"
            />
            <path
              d="M70 14H10C6.686 14 4 16.686 4 20V52C4 55.314 6.686 58 10 58H70C73.314 58 76 55.314 76 52V20C76 16.686 73.314 14 70 14ZM73 50.2C73 52.85 70.85 55 68.2 55H11.8C9.15 55 7 52.85 7 50.2V21.8C7 19.15 9.15 17 11.8 17H68.2C70.85 17 73 19.15 73 21.8V50.2Z"
              fill="url(#paint0_linear_254_1405)"
            />
            <path
              d="M68.2002 16.2H11.8002C8.7122 16.2 6.2002 18.712 6.2002 21.8V50.1999C6.2002 53.2879 8.7122 55.7999 11.8002 55.7999H68.2002C71.2882 55.7999 73.8002 53.2879 73.8002 50.1999V21.8C73.8002 18.712 71.2882 16.2 68.2002 16.2ZM11.8002 17.8H68.2002C70.4062 17.8 72.2002 19.594 72.2002 21.8V47.1999H7.8002V21.8C7.8002 19.594 9.5942 17.8 11.8002 17.8ZM72.2002 50.1999C72.2002 52.4059 70.4062 54.1999 68.2002 54.1999H11.8002C9.5942 54.1999 7.8002 52.4059 7.8002 50.1999V48.7999H72.2002V50.1999Z"
              fill="#83837F"
            />
            <path
              d="M70.0002 13.2H10.0002C6.2502 13.2 3.2002 16.25 3.2002 20V52C3.2002 55.75 6.2502 58.8 10.0002 58.8H17.4002L12.7202 65.04C12.1902 65.746 12.3342 66.75 13.0402 67.28C13.3282 67.496 13.6642 67.6 13.9982 67.6C14.4842 67.6 14.9642 67.38 15.2802 66.96L21.2802 58.96C21.3182 58.908 21.3522 58.854 21.3842 58.8H58.6142C58.6462 58.854 58.6802 58.908 58.7182 58.96L64.7182 66.96C65.0322 67.38 65.5122 67.6 66.0002 67.6C66.3342 67.6 66.6722 67.496 66.9582 67.28C67.6662 66.75 67.8082 65.746 67.2782 65.04L62.5982 58.8H69.9982C73.7482 58.8 76.7982 55.75 76.7982 52V20C76.7982 16.25 73.7482 13.2 69.9982 13.2H70.0002ZM75.2002 52C75.2002 54.868 72.8682 57.2 70.0002 57.2H10.0002C7.1322 57.2 4.8002 54.868 4.8002 52V20C4.8002 17.132 7.1322 14.8 10.0002 14.8H70.0002C72.8682 14.8 75.2002 17.132 75.2002 20V52Z"
              fill="#83837F"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_254_1405"
            x="1.8002"
            y="11.8"
            width="79.5977"
            height="60.3999"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_254_1405"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_254_1405"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_254_1405"
            x1="14.1269"
            y1="17.9355"
            x2="39.1492"
            y2="64.9025"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_254_1405">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default IrTvIcon;
